import { createSlice } from "@reduxjs/toolkit";
import { fetchThingDetails } from "./thingThunk";

const initialState = {
  filterThing:[],
  things: [],
  fullResponse: null,
  selectedThing: {},
  loading: false,
  error: null,
};

const thingSlice = createSlice({
  name: "things",
  initialState,
  reducers: {
     setFilterThing: (state, action) => {
      state.filterThing = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchThingDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchThingDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.fullResponse = action.payload;
        const orgThings = action.payload?.orgThings || {};
        state.things = Object.keys(orgThings).map((thingId) => ({
          id: thingId,
          ...orgThings[thingId].thing, 
          route: orgThings[thingId].currentJourney?.route || "N/A",
          stops: orgThings[thingId].stops?.length || 0,
          passengers: 0, // Add passengers if available in the response
        }));
      })
      .addCase(fetchThingDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});
export const { 
 setFilterThing
} = thingSlice.actions;
export default thingSlice.reducer;